import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  realTimeEmailData: null,
  renderNewEmail: false,
  unreadEmail: null,
  renderEmailList: false,
  emailsLength: [],
  openDraftModal: false,
  emptyEmailInputs: false,
  handleSentEmail: false,
  renderDraft: false,
  foldersList: "",
  isDraftEmail: false,
  draftId: "",
  emptyEmails: false,
  inboxEmailData: [],
  unreadEmailCount: null,
  emailCount: 0,
};
const emailSlice = createSlice({
  name: "email",
  initialState,
  reducers: {
    setRealTimeEmailData: (state, action) => {
      const userId = localStorage.getItem("user_id");
      state.realTimeEmailData = action.payload;
      const data = {
        attachments: [],
        body: action.payload?.body,
        createdDate: action.payload?.createdDate,
        emailId: action.payload?.emailId,
        emailType: action.payload?.emailType,
        externalEmail: null,
        isDraft: action.payload?.isDraft,
        isFav: action.payload?.isFav,
        isRead: action.payload?.isRead,
        isTrash: null,
        parentEmailId: action.payload?.parentEmailId,
        recipientId: userId,
        senderEmail: action.payload?.sender?.email,
        senderFirstName: action.payload?.sender?.firstName,
        senderId: action.payload?.sender?.senderId,
        senderLastName: action.payload?.sender?.lastName,
        senderProfilePicPath: action.payload?.sender?.profilePicPath,
        subject: action.payload?.subject,
      };
      state.inboxEmailData = [data, ...state.inboxEmailData];
      state.emailCount++;
    },
    setEmailCount: (state, action) => {
      state.emailCount = action.payload;
    },
    setInboxEmailData: (state, action) => {
      state.inboxEmailData = action.payload;
    },
    setRenderNewEmail: (state, action) => {
      state.renderNewEmail = action.payload;
    },
    setUnreadEmail: (state, action) => {
      state.unreadEmail = action.payload;
    },
    setRenderEmailList: (state, action) => {
      state.renderEmailList = action.payload;
    },
    setEmailsLength: (state, action) => {
      state.emailsLength = action.payload;
    },
    setOpenDraftModal: (state, action) => {
      state.openDraftModal = action.payload;
    },
    setEmptyEmailInputs: (state, action) => {
      state.emptyEmailInputs = action.payload;
    },
    setHandleSentEmail: (state, action) => {
      state.handleSentEmail = action.payload;
    },
    setRenderDraft: (state, action) => {
      state.renderDraft = action.payload;
    },
    setFolderList: (state, action) => {
      state.foldersList = action.payload;
    },
    setIsDraftEmail: (state, action) => {
      state.isDraftEmail = action.payload;
    },
    setDraftId: (state, action) => {
      state.draftId = action.payload;
    },
    setEmptyEmails: (state, action) => {
      state.emptyEmails = action.payload;
    },
    setInboxEmailRecieve: (state, action) => {
      state.realtimeEmailRecieve = action.payload;
    },
    setUnreadEmailCounts: (state, action) => {
      state.unreadEmailCount = action.payload;
    },
  },
});

export const {
  setRealTimeEmailData,
  setEmailCount,
  setRenderNewEmail,
  setUnreadEmail,
  setRenderEmailList,
  setInboxEmailRecieve,
  setEmailsLength,
  setOpenDraftModal,
  setEmptyEmailInputs,
  setHandleSentEmail,
  setRenderDraft,
  setFolderList,
  setIsDraftEmail,
  setDraftId,
  setEmptyEmails,
  setInboxEmailData,
  setUnreadEmailCounts,
} = emailSlice.actions;

export default emailSlice.reducer;
